import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LoaderService } from '../../core/services/loader.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements OnInit {

  constructor(public loaderService: LoaderService, private cdRef: ChangeDetectorRef) { }

  ngOnInit(): void {
  }
}
